import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/tenants'
import Component from 'components/Tenants'

export default createListViewContainer({ actions, selectors: selectors.tenants })(Component)
